export default "__VITE_ASSET__4ef6ea8d__"